import { isEqualWith, isFunction } from 'lodash-es';

export const isEqualWithoutFunctions = (
    previousValue: unknown,
    currentValue: unknown,
) =>
    isEqualWith(
        previousValue,
        currentValue,
        (previousPropValue, currentPropValue) =>
            isFunction(previousPropValue) && isFunction(currentPropValue)
                ? true
                : undefined,
    );
